import * as React from "react";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import DataTableTemplate from "../Components/DataTableTemplate";
import { PanelContainer } from "../Components/PanelContainer";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { fetchData, getFilterButton, getFilterClearButton, getFilterDate, getFilterInputText, getFilterSelect } from "../Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
export const ControlInsurance = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
    filters: {
      name: { value: "", matchMode: "contains" },
      Mob: { value: "", matchMode: "contains" },
      RegDate: { value: null, matchMode: FilterMatchMode.IN },
      status: { value: null, matchMode: FilterMatchMode.IN },
      org: { value: null, matchMode: FilterMatchMode.IN },
    },
  });
  const statusList = [
    { value: "0", label: "غیرسازمانی" },
    { value: "1", label: "سازمانی" },
  ];
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    reset,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });
  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Mob",
      header: "نام و نام خانوادگی",
      body: (data, options) => data?.Name + " " + data?.Family,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
      filterClear: getFilterClearButton,
    },
    {
      field: "Mob",
      header: "جنسیت",
      body: (data) => sexTemplate(data),
    },
    {
      field: "Mob",
      header: "شماره موبایل",
    },
    { field: "RegDate", header: "تاریخ بیمه نامه" ,
    sortable: true,
    filter: true,
    filterPlaceholder: "نام را وارد کنید",
    showFilterMatchModes: false,
    showFilterOperator: false,
    filterApply: getFilterButton,
    filterElement: (options) =>
      // getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
      getFilterDate(options, '', watch, control),
    filterClear: getFilterClearButton,
  },
    {
      field: "status",
      header: "وضعیت بیمه نامه",
      body: (data) => {
        return data?.org === 1 ? "سازمانی" : "غیرسازمانی";
      },
      filter: true,
      filterPlaceholder: "وضعیت را انتخاب کنید",
      showFilterMatchModes: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterSelect(options, statusList, "org", "وضعیت را انتخاب کنید"),
      filterClear: getFilterClearButton,
    },
    // {
    //   field: "sex",
    //   header: "جنسیت",
    //   body: (data) => (data?.sex === 1 ? "مرد" : "زن"),
    // },
    { field: "ProvinceName", header: "استان" },
    { field: "CityName", header: "شهر" },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <a
          className="text-decoration-underline"
          onClick={() => navigate(`/cpanel/insurance/${data?.uid}`)}
        >
          {data?.coin}
        </a>
      ),
    },
  ];

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("userlist", bodyFormData, handleApiResponse);
  }, [lazyState]);
  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const excelList = userList?.map((item) => ({
        نام: item.Title,
        "تاریخ عضویت": item.CreateDate,
        " دسته بندی": item.catname,
        "حداقل کش بک": item.MinimumCashBack,
        "حداکثر کش بک": item.MaxsimumCashBack,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };
  const header = (
    <FontAwesomeIcon
      icon={"file-excel"}
      size={40}
      onClick={exportExcel}
      className=" p-2 rounded  bg-info text-white"
    />
  );
  const sexTemplate = (rowData) => {
    return rowData.sex === 1 ? "مرد" : "زن";
  };
  return (
    <PanelContainer title={"بیمه نامه"}>
      <Tooltip target=".export-buttons>button" position="bottom" key="" />
      <DataTableTemplate
        lazyState={lazyState}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={userList}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        // setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
        header={header}
      />
    </PanelContainer>
  );
};
